<template>
    <section class="application-list">
        <div v-if="applications.length === 0" class="text-center py-5">
            <div class="mb-4">
                <i class="fa fa-file-text fa-4x text-muted mb-3"></i>
                <h4 class="text-muted">No Applications Yet</h4>
                <p class="text-muted">Get started by creating your first application for accreditation.</p>
            </div>
            <button
                class="btn btn-primary"
                :disabled="hasInProcessApplication"
                @click="createApplication"
                v-tooltip="hasInProcessApplication ? 'You already have an application in process' : null"
            >
                <i class="fa fa-plus"></i> Create New Application
            </button>
        </div>

        <div v-else>
            <div class="table-responsive mb-3">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Application</th>
                            <th>Status</th>
                            <th class="text-end">Dates</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="application in applications"
                            :key="application.id"
                            :class="{ 'table-secondary opacity-50': application.is_expired }"
                        >
                            <td>
                                <a
                                    v-if="!application.is_expired"
                                    :href="application.permalink"
                                    class="fw-bold text-decoration-none"
                                >
                                    {{ application.title }}
                                </a>
                                <span v-else class="text-muted">
                                    {{ application.title }}
                                </span>
                            </td>
                            <td>
                                <span v-if="application.status === 'accredited'" class="badge bg-success">
                                    Accredited
                                </span>
                                <span v-else-if="application.status === 'in-review'" class="badge bg-info">
                                    In Review
                                </span>
                                <span v-else-if="application.status === 'in-process'" class="badge bg-warning text-dark">
                                    In Process
                                </span>

                                <span v-if="application.is_expired" class="badge bg-danger ms-1">
                                    Expired
                                </span>
                            </td>
                            <td class="text-end">
                                <div v-if="application.accreditation_start_date && application.accreditation_end_date" class="small">
                                    {{ application.accreditation_start_date }} - {{ application.accreditation_end_date }}
                                </div>
                                <div v-else-if="application.submission_date" class="small text-muted">
                                    Submitted: {{ application.submission_date }}
                                </div>
                                <div v-else class="small text-muted">
                                    —
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <button
                    class="btn btn-primary"
                    :disabled="hasInProcessApplication"
                    @click="createApplication"
                    v-tooltip="hasInProcessApplication ? 'You already have an application in process' : null"
                >
                    <i class="fa fa-plus"></i> Create New Application
                </button>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['applications'],
        computed: {
            hasInProcessApplication() {
                return this.applications.some(app => app.status === 'in-process');
            }
        },
        methods: {
            createApplication() {
                $.ajax({
                    url: localized.resturl + '/application/create',
                    method: 'POST',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader( 'X-WP-Nonce', localized.restnonce );
                    },
                    dataType: 'json',
                    success: (result) => {
                        if(result.success) {
                            toastr.success(result.message, 'Success');
                            // Redirect to the new application
                            window.location.href = result.data.permalink;
                        } else {
                            toastr.error(result.message, 'Error');
                        }
                    },
                    error: function(result) {
                        toastr.error('An error occurred while creating the application', 'Error');
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .table-secondary.opacity-50 a {
        pointer-events: none;
        color: #6c757d;
    }
</style>
